import React from 'react';
import { GenericDetailPage } from '../../../components/generic';
import { useStoreCatalog, StoreCatalog } from './useData';
import { moduleConfig, getDetailSections, getStatusBadges } from './config';

const Detail: React.FC = () => (
  <GenericDetailPage<StoreCatalog>
    useData={useStoreCatalog}
    config={{
      ...moduleConfig,
      getDetailSections,
      getStatusBadges,
    }}
  />
);

export default Detail;
